import PermissionCheck from "./PermissionCheck";

export {PermissionCheck};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/PermissionCheck/index.tsx